import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {LocalizedText} from '@app/model/equipment.model';

@Injectable({
	providedIn: 'root'
})
export class LocalizeService {
	readonly #languageShortCode: keyof LocalizedText;

	constructor(@Inject(LOCALE_ID) private locale: string) {
		this.#languageShortCode = locale.substring(0, 2).toLowerCase() as keyof LocalizedText;
	}

	localize(localizedText?: LocalizedText | undefined | null): string {
		if (localizedText === null || localizedText === undefined) {
			return '';
		}

		if (localizedText[this.#languageShortCode] === undefined) {
			return localizedText.en;
		}

		return localizedText[this.#languageShortCode];
	}
}
